import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
              おかやま行政書士事務所
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              岡山市を中心に、建設業許可、会社設立、相続手続きなど、幅広い行政手続きをサポートいたします。
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer" aria-label="LINE">
                <i className="ri-line-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">サイトマップ</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  ホーム
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  事業内容
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/recruit" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  求人情報
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  ブログ・新着情報
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">主な業務</h4>
            <ul className="space-y-3 text-gray-400">
              <li>建設業許可申請</li>
              <li>飲食店営業許可</li>
              <li>会社設立・法人手続き</li>
              <li>相続・遺言手続き</li>
              <li>自動車登録・車庫証明</li>
              <li>在留資格・帰化申請</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">お問い合わせ</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-fill text-blue-400 text-xl mt-1 flex-shrink-0"></i>
                <div className="text-gray-400">
                  <p className="text-sm mb-1">〒700-0000</p>
                  <p>岡山市北区○○町1-2-3</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-fill text-blue-400 text-xl flex-shrink-0"></i>
                <a href="tel:0860123456" className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  086-012-3456
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-printer-fill text-blue-400 text-xl flex-shrink-0"></i>
                <span className="text-gray-400 whitespace-nowrap">086-012-3457</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-fill text-blue-400 text-xl mt-1 flex-shrink-0"></i>
                <div className="text-gray-400">
                  <p>9:00 〜 18:00</p>
                  <p className="text-sm">定休日：日曜日・祝日</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; 2026 おかやま行政書士事務所. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}